var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsistency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Consistency"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3459_2744",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 72,
    height: 72,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3459_2744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "target",
    d: "M36 66C31.85 66 27.95 65.2125 24.3 63.6375C20.65 62.0625 17.475 59.925 14.775 57.225C12.075 54.525 9.9375 51.35 8.3625 47.7C6.7875 44.05 6 40.15 6 36C6 31.85 6.7875 27.95 8.3625 24.3C9.9375 20.65 12.075 17.475 14.775 14.775C17.475 12.075 20.65 9.9375 24.3 8.3625C27.95 6.7875 31.85 6 36 6C40.15 6 44.05 6.7875 47.7 8.3625C51.35 9.9375 54.525 12.075 57.225 14.775C59.925 17.475 62.0625 20.65 63.6375 24.3C65.2125 27.95 66 31.85 66 36C66 40.15 65.2125 44.05 63.6375 47.7C62.0625 51.35 59.925 54.525 57.225 57.225C54.525 59.925 51.35 62.0625 47.7 63.6375C44.05 65.2125 40.15 66 36 66ZM36 60C42.7 60 48.375 57.675 53.025 53.025C57.675 48.375 60 42.7 60 36C60 29.3 57.675 23.625 53.025 18.975C48.375 14.325 42.7 12 36 12C29.3 12 23.625 14.325 18.975 18.975C14.325 23.625 12 29.3 12 36C12 42.7 14.325 48.375 18.975 53.025C23.625 57.675 29.3 60 36 60ZM36 54C31 54 26.75 52.25 23.25 48.75C19.75 45.25 18 41 18 36C18 31 19.75 26.75 23.25 23.25C26.75 19.75 31 18 36 18C41 18 45.25 19.75 48.75 23.25C52.25 26.75 54 31 54 36C54 41 52.25 45.25 48.75 48.75C45.25 52.25 41 54 36 54ZM36 48C39.3 48 42.125 46.825 44.475 44.475C46.825 42.125 48 39.3 48 36C48 32.7 46.825 29.875 44.475 27.525C42.125 25.175 39.3 24 36 24C32.7 24 29.875 25.175 27.525 27.525C25.175 29.875 24 32.7 24 36C24 39.3 25.175 42.125 27.525 44.475C29.875 46.825 32.7 48 36 48ZM36 42C34.35 42 32.9375 41.4125 31.7625 40.2375C30.5875 39.0625 30 37.65 30 36C30 34.35 30.5875 32.9375 31.7625 31.7625C32.9375 30.5875 34.35 30 36 30C37.65 30 39.0625 30.5875 40.2375 31.7625C41.4125 32.9375 42 34.35 42 36C42 37.65 41.4125 39.0625 40.2375 40.2375C39.0625 41.4125 37.65 42 36 42Z",
    fill: "url(#paint0_linear_3459_2744)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3459_2744",
    x1: 21.885,
    y1: 6,
    x2: 36.9734,
    y2: 67.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1AEFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsistency);
export default __webpack_public_path__ + "static/media/Consistency.dc62875d384cd7e64904871ed921dbea.svg";
export { ForwardRef as ReactComponent };